import { render, staticRenderFns } from "./complaintClass.vue?vue&type=template&id=31b9e7a5&"
import script from "./complaintClass.vue?vue&type=script&lang=js&"
export * from "./complaintClass.vue?vue&type=script&lang=js&"
import style0 from "./complaintClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports